import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "ms-1" }
const _hoisted_3 = {
  key: 0,
  class: "d-block text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConsulteGrid, {
      columns: _ctx.colunas,
      "data-source": _ctx.dataSource,
      "titulo-relatorio": "Salas e ambientes",
      "nome-arquivo-relatorio": "Salas_ambientes"
    }, {
      header: _withCtx(() => [
        (_ctx.permissao.incluir)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'sala_create' },
              class: "btn btn-primary rounded-pill ms-2"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("i", {
                  class: "uil uil-plus",
                  "aria-hidden": "true"
                }, null, -1),
                _createTextVNode(" Cadastrar ", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      botaoSelecionar: _withCtx(({ row }) => [
        _createVNode(_component_router_link, {
          to: { name: 'sala_create', params: { id: row.gesSalaId } },
          class: "btn btn-sm btn-outline-secondary",
          "aria-label": `${_ctx.permissao.alterar ? 'Editar' : 'Abrir'} o ambiente ${row.numero}`
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.permissao.alterar ? 'mdi mdi-pencil' : 'mdi mdi-eye'),
              "aria-hidden": "true"
            }, null, 2),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.permissao.alterar ? 'Editar' : 'Abrir'), 1)
          ]),
          _: 1
        }, 8, ["to", "aria-label"])
      ]),
      area: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_ctx.formatarArea(row.area)), 1)
      ]),
      capacidade: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.capacidade ?? '') + " ", 1),
        (row.capacidadeAjusteManual)
          ? (_openBlock(), _createElementBlock("small", _hoisted_3, "ajustada"))
          : _createCommentVNode("", true)
      ]),
      ativo: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(row.ativo === 0 ? 'Não' : 'Sim'), 1)
      ]),
      _: 1
    }, 8, ["columns", "data-source"])
  ]))
}